/**
 * Utilitná funkcia pre konverziu url parametrov na objekt
 * @param {string} - Parametre pre konverziu
 * @returns {object} - Parametre vo forme objektu
 * @example
 * ```javascript
 * import paramsToObject from 'utilities/lib/paramsToObject';
 *
 * console.log(paramsToObject('property=PropertyValue&anotherProperty=AnotherPropertyValue'));
 * // {
 * //  property: 'PropertyValue',
 * //  anotherProperty: 'AnotherPropertyValue',
 * // }
 * ```
 */
export default function paramsToObject(params) {
    if (!params || params.length === 0) {
        return {};
    }
    return params.split('&').reduce(function (acc, part) {
        var _a = part.split('='), key = _a[0], value = _a[1];
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
    }, {});
}
